module.exports = __webpack_public_path__ + "img/teacup-without-handle.503a7561.png";